export const environment = {
    production: false,
    msalConfig: {
        auth: {
            clientId: '181836c1-e204-459e-9c83-70aa839c9b4a', 
            authority: 'https://login.microsoftonline.com/46c5178e-a0f4-4f4d-8c40-9598e3d11860',
        }
    },
    graphApiConfig:{
        scopes: ['user.read'],
        uri: 'https://graph.microsoft.com/v1.0/me'
    },
    apiConfig: {
        uri: 'https://cw-va-api-uat.azurewebsites.net/', // your API base URL
        scopes: [
            'api://028fd2f6-b90d-4efe-ad3d-0b76897a5910/access_as_user' // backend API scope
        ]
    },
    apiBaseUrl: 'https://cw-va-api-uat.azurewebsites.net',
    appraisalApiConfig:{
        baseUrl: 'https://cw-va-api-uat.azurewebsites.net/api/v1/appraisal'
    },
    argusApiConfig:{
        baseUrl: 'https://cw-va-api-uat.azurewebsites.net'
    },
    bookmarksApiConfig:{
        baseUrl: 'https://cw-va-api-uat.azurewebsites.net/api/v1/bookmarks'
    },
    ratingsApiConfig:{
        baseUrl: 'https://cw-va-api-uat.azurewebsites.net/api/v1'
    },
    signalRConfig: {
        hubUrl: 'https://cw-va-api-uat.azurewebsites.net/hubs/grid-refresh',
        refreshEvents: ['AppraisalUpdated'],
        pollingIntervalMs: 10000
    }
};